import { subclientValidate } from '../../application/dtos/subclient_validate'

export class subclientEntity {
    constructor({id, attributes}){
        this.id = id;
        this.attributes = attributes;
    }

    isValid() {
        return subclientValidate(this);
    }
}